@if ((range | async); as range) {
  <div class="range" [class.clickable]="!unclickable"
    (click)="onClick()"
    >
    <span title="{{range[1]}}">
      {{ range[0] }}
    </span>
  </div>
}
